// const baseUrl = 'http://localhost:8888/mkwp/wp-json/wp/v2/';
const authUrl = 'http://localhost:8888/mkwp/wp-json/jwt-auth/v1';

export default class Validation {
    hasNumber(myString) {
      // eslint-disable-next-line
      return /\d/.test(myString);
    }

    hasStreetNumber(myString) {
      // eslint-disable-next-line
      return /[ABCDENSW]\d/.test(myString);
    }

    hasLetter(myString) {
      // eslint-disable-next-line
      return /[a-zA-Z]/.test(myString);
    }

    hasCapital(myString) {
      // eslint-disable-next-line
      return /[A-Z]/.test(myString);
    }

    hasSpecial(myString) {
      // eslint-disable-next-line
      return /[!@#$%^&*()_+\-=\[\]{};~`':"\/\\|,\.<>?]/.test(myString);
    }

    validateEmail(email) {
      // eslint-disable-next-line
      const emlpattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emlpattern.test(email);
    }

    validatePass(pwd) {
      // eslint-disable-next-line
      const pwdpattern = /^(?=.*[A-Z])(?=.*[A-Za-z])(?=.*\d)(?=.*[$\\\-\.\]@$!~^+|_)(/[;:,{}<>"'`=%*#?&])[A-Za-z\d$\\\-\.\]@$!~^+|_)(/[;:,{}<>"'`=%*#?&]{8,}$/;
      return pwdpattern.test(pwd);
    }

    validatePhone(phn) {
      // eslint-disable-next-line
      const phnpattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      return phnpattern.test(phn);
    }

    validateSSN(ssn) {
      // eslint-disable-next-line
      const ssnpattern = /^[0-9\-]{11}$/;
      return ssnpattern.test(ssn);
    }

    checkDate(str, max) {
      if (str.indexOf('-') > -1){
        if(str.length > 1){
          if (str.charAt(0) !== '0'){
            var num0 = parseInt(str, 10);
            if (num0 === 1 || num0 === -1){
              return '01';
            } else if (max > 12){
              if (num0 === 2 || num0 === -2 || num0 === -3){
                return '02';
              } else if (num0 === 3 || num0 === -3){
                return '03';
              }
            }
          } else {
            return str.charAt(0);
          }
        } else {
          return '';
          // if (max > 12){
          //   return '-';
          // } else {
          //   return '0';
          // }
        }
      } else if (str.charAt(0) !== '0' || str === '00') {
        var num = parseInt(str, 10);
        if (num === 0 || num > max) {
          return str.charAt(0);
        }
        str = num > parseInt(max.toString().charAt(0), 10) && num.toString().length === 1 ? '0' + num : num.toString();
      };
      return str;
    }
    checkYear(str, min, max) {
      if (str.length === 4) {
        var num = parseInt(str, 10);
        if (num < min || num > max) {
          return str.charAt(0)+str.charAt(1)+str.charAt(2);
        }
      };
      return str;
    }
    checkPhoneNum(str, min) {
      if (str.length === 3) {
        var num = parseInt(str, 10);
        if (num < min) {
          return str.charAt(0)+str.charAt(1)
        }
      };
      return str;
    }

    checkAll(arr){
      return arr.every( v => v === arr[0] );
    }

    authenticate(username, password) {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');

      return fetch(`${authUrl}/token`, {
          method: 'POST',
          headers,
          body: JSON.stringify({username, password})
      }).then(res => {
          if (!res.ok) {
              throw Error(res.statusText);
          }

          return res.json();
      });
    }
}



// WEBPACK FOOTER //
// ./src/utils/Validation.js